import { render, staticRenderFns } from "./MailSettingsCheckboxInput.vue?vue&type=template&id=704ccae2"
import script from "./MailSettingsCheckboxInput.vue?vue&type=script&lang=js"
export * from "./MailSettingsCheckboxInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports